import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import PartnerStrip from "@/components/site/PartnerStrip";
import Announcements from "@/components/site/Announcements";
import WhyAttend from "@/components/site/WhyAttend";
import Speakers from "@/components/site/Speakers";
import Program from "@/components/site/Program";
import MainSponsors from "@/components/site/MainSponsors";
import Venue from "@/components/site/Venue";
import TheVenue from "@/components/site/TheVenue";
import EarlyAccess from "@/components/site/EarlyAccess";
import Footer from "@/components/site/Footer";

const FALLBACK_SETTINGS = {
  mode: "early_access",
  date_label: "13 April 2027",
  venue: "Grieghallen, Bergen",
  positioning:
    "Frontier AI, strategy and practical application — one day, one room, ~700 leaders, builders and researchers. 13 April 2027, Grieghallen, Bergen.",
  hero_eyebrow: "Norwegian AI Summit • 2027",
  hero_headline: "The Next|Shift",
  hero_subheadline: "AI is changing how we build, lead and compete.",
  hero_meta_date_value: "13 April 2027",
  hero_meta_date_note: "One day only",
  hero_meta_duration_value: "One full day",
  hero_meta_duration_note: "08:30–17:30",
  hero_meta_venue_value: "Grieghallen",
  hero_meta_venue_note: "Bergen, Norway",
  hero_meta_audience_value: "~700 in the room",
  hero_meta_audience_note: "Deliberately limited",
  hero_partners_label: "Partnerships in progress",
};

export default function Landing({ variant = "default" }) {
  const [content, setContent] = useState({
    settings: FALLBACK_SETTINGS,
    speakers: [],
    program: [],
    partners: [],
    announcements: [],
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/content")
      .then((r) => {
        if (cancelled) return;
        setContent({
          settings: r.data?.settings || FALLBACK_SETTINGS,
          speakers: r.data?.speakers || [],
          program: r.data?.program || [],
          partners: r.data?.partners || [],
          announcements: r.data?.announcements || [],
        });
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, []);

  const { settings, speakers, program, partners, announcements } = content;

  return (
    <div
      data-testid="landing-root"
      className={`min-h-screen bg-[var(--bg)] text-[var(--fg)] ${
        variant === "purple" ? "theme-purple" : ""
      }`}
    >
      <Nav settings={settings} />
      <Hero settings={settings} speakers={speakers} variant={variant} />
      <PartnerStrip partners={partners} />
      <Speakers speakers={speakers} loaded={loaded} />
      <Announcements items={announcements} />
      <WhyAttend />
      <MainSponsors />
      <Program program={program} />
      <Venue />
      <TheVenue />
      <EarlyAccess settings={settings} />
      <Footer settings={settings} />
    </div>
  );
}
